import Conditional from "@repo/shared-ui/Conditional";
import { FC } from "react";
import { twMerge } from "tailwind-merge";
import Image from "next/image";
import { getFullUrl } from "../../../utils/helper";
interface FallbackComponentProps {
    condition: boolean;
    imageUrl: string;
    title: string;
    buttonText: string;
    onClick: () => void;
    imageAlt?: string;
    className?: string;
    imageClassName?: string;
    titleClassName?: string;
    buttonClassName?: string;
}

const FallbackComponent: FC<FallbackComponentProps> = ({
    condition,
    imageUrl,
    title,
    buttonText,
    onClick,
    imageAlt = "No stocks",
    className,
    imageClassName,
    titleClassName,
    buttonClassName,
}) => {
    return (
        <Conditional if={condition}>
            <div className={twMerge("flex flex-col items-center justify-center", className)}>
                <Image width={80} height={80} className={twMerge("h-20 w-20", imageClassName)} src={getFullUrl(imageUrl)} alt={imageAlt} />
                <h2 className={twMerge("", titleClassName)}>{title}</h2>
                <button
                    type="button"
                    className={twMerge("inline-flex min-w-[160px] cursor-pointer items-center justify-center rounded-full bg-gradient-to-r from-[#FF6700] to-[#FF8900] px-6 py-2 text-sm font-medium text-white max-md:min-w-[120px] max-md:px-4 max-md:py-1.5", buttonClassName)}
                    onClick={onClick}
                >
                    {buttonText}
                </button>
            </div>
        </Conditional>
    );
};

export default FallbackComponent;

